import AppTypes from './app.types';
import UserTypes from '../user/user.types';
import ContactTypes from '../contact/contact.types';
import AnyAction from 'store/anyActions';
import AppState from './app.state';
import { LoadingStates } from 'store/state';

// this gets overwritten on app load, dont rely on it for default values
const defaultState : AppState = {
    error: false,
    message: '',
    logoURL: '',
    name: '',
    plugins: [],
    loading: true,
    ID: '',
    appConfig: { 
        afterCallWorkInitialTimeoutSeconds: 20,
        chatAfterCallWorkInitialTimeoutSeconds:60,
        defaultNumberDPAPassesRequiredForPass: 2,
    },
    callbacksEnabled: false,
    instances: [],
    instance: undefined,
    identityManagement: undefined,
    forms: {},
    keywordsError: false,
    keywordsSuccess: false,
    keywordsLoading: false,
    features:[]
};

export default function(state: AppState = defaultState, action: AnyAction) {
    switch (action.type) {
        case AppTypes.INIT_APP_LOADING:
            return { ...state, loading: true };
        case AppTypes.SELECT_INSTANCE:
            return { ...state, instance: action.payload.instance };
        case AppTypes.CLEAR_INSTANCE:
            return { ...state, instance: undefined };
        case AppTypes.INIT_APP_SUCCESS:
            return { ...action.payload, forms: {}, error: false, loading: false };
        case AppTypes.INIT_APP_FAIL:
            return { ...defaultState, ...action.payload, error: true };
        case AppTypes.PLUGIN_INSTALLED:
            return {
                ...state,
                plugins: state.plugins.map(p => {
                    if (p.name === action.payload.name) {
                        p.iframe = action.payload.iframe;
                    }
                    return p;
                }),
            };
        case AppTypes.SHOW_PLUGIN:
            return {
                ...state,
                plugins: state.plugins.map(p => {
                    if (p.name === action.payload) {
                        p.hidden = false;
                    }
                    return p;
                }),
            };
        case AppTypes.HIDE_PLUGIN:
            return {
                ...state,
                plugins: state.plugins.map(p => {
                    if (p.name === action.payload) {
                        p.hidden = true;
                    }
                    return p;
                }),
            };
        case AppTypes.RESET_PLUGIN:
            return {
                ...state,
                plugins: state.plugins.map(p => {
                    if (p.name === action.payload) {
                        delete p.hidden;
                        delete p.titleTag;
                    }
                    return p;
                }),
            };
        case ContactTypes.CLEAR_CONTACT:
        case UserTypes.USER_AVAILABLE:
            return {
                ...state,
                plugins: state.plugins.map(p => {
                    delete p.hidden;
                    delete p.titleTag;
                    return p;
                }),
            };
        case AppTypes.UPDATE_PLUGIN_TITLE_TAG:
            return {
                ...state,
                plugins: state.plugins.map(p => {
                    if (p.name === action.payload.name) {
                        p.titleTag = action.payload.tag;
                    }
                    return p;
                }),
            };
        case AppTypes.LOADING_FORM:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.payload]: {
                        state: LoadingStates.LOADING,
                    },
                },
            };
        case AppTypes.FORM_NOT_FOUND:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.payload]: {
                        state: LoadingStates.NOT_FOUND,
                    },
                },
            };
        case AppTypes.FORM_LOADED:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.payload.name]: {
                        state: LoadingStates.LOADED,
                        form: action.payload.form,
                    },
                },
            };
        case AppTypes.FORM_ERROR:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    [action.payload]: undefined,
                },
            };
        case AppTypes.CCP_LOGOUT:
        case UserTypes.LOGOUT:
            return { ...defaultState };
        case AppTypes.UPDATE_INSTANCE_SETTINGS:
            return {
                ...state,
                instance: {
                    ...state.instance,
                    settings: {
                        ...state.instance?.settings,
                        ...action.payload,
                        keywordManagement: {
                            ...state.instance?.settings?.keywordManagement,
                        }
                    }
                }
            };
        case AppTypes.UPDATE_KEYWORDS_ERROR:
            return {
                ...state,
                keywordsError: action.payload
            };

        case AppTypes.UPDATE_KEYWORDS_LOADING:
            return {
                ...state,
                keywordsLoading: action.payload,
            };

        case AppTypes.UPDATE_KEYWORDS_SUCCESS:
            return {
                ...state,
                keywordsSuccess: action.payload,
                keywordsError: false
            };
        case AppTypes.SET_COMPANY_GROUPS:
            return {
                ...state,
                companyGroups: action.payload
            }

        default:
            return state;
    }
}
